import { AdornerModel } from '../../views/components/adorner/adorner';
import { autoinject } from "aurelia-framework";

@autoinject
export class AdornerService {

    constructor() {}

    private _showFuncs: (( model: AdornerModel) => void)[] = []
    private _hideFuncs: ((model: AdornerModel) => void)[] = []

    // SHOW ADORNER FUNCTIONS
    public onAdd(funcShow: (model: AdornerModel) => void) {
        this._showFuncs.push(funcShow);
    }

    public add(model: AdornerModel) {
        for (const func of this._showFuncs) {
            func(model);
        }
    }

    // HIDE ADORNER FUNCTIONS
    public onRemove(funcHide: (model: AdornerModel) => void) {
        this._hideFuncs.push(funcHide);
    }

    public remove(model: AdornerModel) {
        for (const func of this._hideFuncs) {
            func(model);
        }
    }

}
